<template>
  <div>
    <div ref="form" class="table-biao computer_right_cont_box">
      <div class="thead flex-col">
        <div class="bd11 flex-col">
          <div class="block13 flex-row">
            <span class="td-width-head left-title">
              {{ untia }}
            </span>
            <span class="zhongjian" v-for="(item, index) in years" :key="index">
              <span
                class="td-width-span td-width-txt td-width-txt-first td-width-txt2"
                >{{ item }}</span
              >
              <span class="td-width-span td-width-txt">{{
                $t("FinancialHighlight.Change")
              }}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="table-tbody">
        <div
          class="tbody flex-col"
          v-for="(items, index) in profitablitylist"
          :key="index"
        >
          <div class="bd11 flex-col">
            <div class="block13 flex-row">
              <span class="td-width thead-title left-title">
                {{ items.name }}
                <span></span>
              </span>
              <span
                class="td-width zhongjian"
                v-for="(item, index) in items.lists"
                :key="index"
                v-show="indexlist.includes(index)"
              >
                <el-tooltip
                  :disabled="item.value.length < 8"
                  :content="item.value"
                  placement="top"
                >
                  <span
                    class="td-width-span td-width-txt td-width-txt-first td-width-txt2"
                    >{{ item.value  }}</span
                  >
                </el-tooltip>
                <span class="td-width-span td-width-txt">
                  <span>{{ item.changes == "n.a." ? " " : "" }}</span>
                  <svg
                    v-if="item.status == '0' ? true : false"
                    t="1718948533724"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4505"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M917.7088 491.7248 107.008 491.7248c-11.776 0-21.2992 9.6256-21.2992 21.2992s9.6256 21.2992 21.2992 21.2992l810.7008 0c11.776 0 21.2992-9.6256 21.2992-21.2992S929.3824 491.7248 917.7088 491.7248z"
                      p-id="4506"
                      fill="#bfbfbf"
                    ></path>
                  </svg>
                  <svg
                    t="1718948802984"
                    v-if="item.status == '1'"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4896"
                    width="16"
                    height="16"
                  >
                    <path
                      d="M512.687 84.864l-261.28 348.26h170.341v509.164h181.866v-509.164h170.341l-261.265-348.26zM512.687 84.864z"
                      fill="#55B419"
                      p-id="4897"
                    ></path>
                  </svg>

                  <svg
                    t="1718948842869"
                    v-if="item.status == '2'"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5099"
                    width="16"
                    height="16"
                  >
                    <path
                      d="M511.313 939.136l261.28-348.26-170.341 0 0-509.164-181.866 0 0 509.164-170.341 0 261.265 348.26zM511.313 939.136z"
                      fill="#d81e06"
                      p-id="5100"
                    ></path>
                  </svg>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="createDialog"
      custom-class="dialog_normal"
      @close="Cancel()"
      :append-to-body="true"
    >
      <div class="detail_cont">
        <h3>{{ $t("CreditOpinion.PleaseSelectTheYeartoDisplay") }}</h3>
        <div class="dialog_detail_next-title">
          {{ $t("CreditOpinion.SelectUptoThreeYears") }}
        </div>

        <el-checkbox-group v-model="checkedCities" :max="3">
          <el-checkbox-button
            v-for="city in yearslist"
            :label="city"
            :disabled="nodataYears.includes(city) || yearslist.length < 4"
            :key="city"
            >{{ city }}
          </el-checkbox-button>
        </el-checkbox-group>

        <div class="btn_box flex_between_box">
          <!-- <button class="btn_export cansel" @click="Cancel()">
            {{ $t("CreditOpinion.Cancel") }}
          </button> -->
          <button
            class="btn_export"
            :disabled="checkedCities.length != 3"
            @click="checkYear"
          >
            {{ $t("CreditOpinion.Select") }}
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    profitablitylist: {
      type: Array,
      default: function () {},
    },
    yearslist: {
      type: Array,
      default: function () {},
    },
    nodataYears: {
      type: Array,
      default: function () {
        return [];
      },
    },
    untia: {
      type: String,
      default: "",
    },
    createDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      indexlist: [0, 1, 2],
      defatindex: 0,
      profitablitylist2: [
        {
          lists: [
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
          ],
          name: "Return on Equity:",
        },
        {
          lists: [
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
          ],
          name: "Return on Assetsd:",
        },
        {
          lists: [
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
          ],
          name: "",
        },
      ],
      // createDialog: true,
      years: ["", "", ""],
      checkedCities: ["", "", ""],
      windows: window,
      moreclose: false,
    };
  },
  created() {},

  watch: {
    $route: {
      handler(val, oldval) {
        this.Indexy = val.path.replace("/", ""); //当前活动路由
      },
      // 深度观察监听
      deep: true,
    },
    profitablitylist: {
      handler(val, oldval) {
        this.profitablitylist = val;
      },
      deep: true,
    },
    nodataYears: {
      handler(val, oldval) {
        this.nodataYears = val;
      },
      deep: true,
    },
    yearslist: {
      handler(val, oldval) {
        this.yearslist = val;
        this.getyears();
      },
      deep: true,
    },
  },
  mounted() {
    this.getyears();
  },

  methods: {
    More() {
      this.moreclose = true;
    },
    closmoreDialog(value) {
      this.moreclose = value;
    },
    diffArray(arr1, arr2) {
      return [
        ...arr1.filter((x) => !arr2.includes(x)),
        ...arr2.filter((x) => !arr1.includes(x)),
      ];
    },
    getyears() {
      if (this.windows.innerWidth > 821) {
        let checkYearArr = this.diffArray(this.yearslist, this.nodataYears);
        if (checkYearArr.length < 3) {
          let nodedateYears = this.nodataYears.slice(
            0,
            3 - checkYearArr.length,
          );
          this.checkedCities = [...checkYearArr, ...nodedateYears];
        } else {
          this.checkedCities = checkYearArr.slice(0, 3);
        }
      }

      var lis = [];
      this.checkedCities.map((item) => {
        lis.push(item);
      });

      this.years = lis.sort(function (a, b) {
        return b - a;
      });
      this.checkYear();
    },
    checkYear() {
      var list = [];
      this.checkedCities.map((item) => {
        list.push(item);
      });

      this.years = list.sort(function (a, b) {
        return b - a;
      });

      this.indexlist = [];
      this.yearslist.map((item, index) => {
        this.checkedCities.map((ite, inde) => {
          if (item == ite) {
            this.indexlist.push(index);
          }
        });
      });
      this.$emit("createDialogcheck", false);
    },
    Cancel() {
      this.$emit("createDialogcheck", false);
    },
  },
};
</script>
<style scoped lang="less">
// 表格
.td {
  margin: 1.0714285714285714rem 0 0 1.7857142857142858rem;
}

.flex-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.rightBox.leftBox {
  display: inline-block;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.changeBox {
  display: flex;
  align-items: center;
}

.thead {
  background: #f2f5f9;
  z-index: 405;
  // height: 3.6714285714285716rem;
  // line-height: 3.5714285714285716rem;
  padding-right: 1.4285714285714286rem;
  position: relative;
  border-bottom: 0.07142857142857142rem solid #cccccc;
}
.span_ {
  height: max-content;
  display: flex;
  align-items: center;
  font-family: "Arial Bold";
}
.thead .td-width:first-child {
  // border-bottom: 0.07142857142857142rem solid #cccccc;
}

.tbody {
  z-index: 405;
  padding-right: 1.4285714285714286rem;
  position: relative;
  border-bottom: 0.07142857142857142rem solid #cccccc;
}

.thead-img {
  width: 2.142857142857143rem;
  height: 2.142857142857143rem;
  background: #8497ab;
  border-radius: 50%;
  text-align: center;
  line-height: 2.142857142857143rem;
  position: relative;
  top: -0.35714285714285715rem;
}

.td-width-head {
  // flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Arial Bold";
  font-size: 18px;
  color: #1a2332;
  height: 50px;
  line-height: 28px;
  padding: 11px 0px;
  text-align: left;
}

.td-width {
  // flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: "Arial Bold";
  font-size: 18px;
  color: #1a2332;
  min-height: 80px;
  line-height: 58px;
  padding: 11px 0px;
  text-align: left;
}

.table-tbody {
  position: relative;
}
.block13 {
  min-height: 50px;
  line-height: 50px;
}
.juli {
  margin-left: 2.142857142857143rem;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.table-biao {
  height: auto;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 4px;
  margin-top: 20px;
}

.td-width-span {
  // flex: 1;
  // height: 5.714285714285714rem;
  // line-height: 5.714285714285714rem;
  // text-align: center;
}

.td-width-txt {
  text-align: right;
  width: 50%;
  // text-align: left;
  white-space: pre-line;
  /* 换行 */
  overflow: hidden;
  /* 隐藏超出部分 */
  text-overflow: ellipsis;
  /* 显示省略号 */
  display: flex;
  align-items: center;
  // justify-content: center;
  justify-content: flex-start;
}
.td-width-txt span {
  margin-right: 10px;
  // min-width: 70px;
}

/deep/.el-checkbox__label {
  color: #022955ff !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  color: #022955ff !important;
}

/deep/ .el-checkbox-button__inner {
  font-size: 20px;
  color: #1a2332;
  background: #f5f5f5;
  border-radius: 10px !important;
}

/deep/ .el-checkbox-button {
  margin-right: 6px;
  margin-bottom: 10px;
  width: 116px;
}

/deep/ .el-checkbox-button:nth-of-type(6n + 6) {
  margin-right: 0rem !important;
}

/deep/ .el-checkbox-button:first-child .el-checkbox-button__inner {
  border: none;
}

/deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner {
  background: #ffffff;
  color: #1a2332;
  border: 1px solid #1290c9;
}

.thead-title {
  display: flex;
  align-items: center;
}

.left-title {
  background: #f2f5f9ff;
  padding-left: 20px;
  width: 480px;
}

.dialog_detail_title {
  font-family: "Arial Bold";
  font-size: 1.4285714285714286rem;
  color: #1a2332;
}

.dialog_detail_next-title {
  font-size: 20px;
  color: #8497ab;
  line-height: 24px;
  text-align: left;
  height: 24px;
  margin-top: 10px;
  margin-bottom: 20px;
}

/deep/ .el-checkbox-button.is-disabled .el-checkbox-button__inner {
  background: #f5f5f5;
}

/deep/ .el-checkbox-group {
  font-size: 0;
  display: flex;
  flex-wrap: wrap;
  max-height: 460px;
  overflow: auto;

  margin-bottom: 20px;
}
.cansel {
  background-color: #8497ab !important;
}
::v-deep .el-dialog__body {
  padding: 30px !important;
}
.detail_cont h3 {
  font-size: 26px;
}
.btn_export {
  width: 210px;
  height: 60px;
  font-size: 20px;
}

::v-deep .dialog_normal {
  width: 800px !important;
}

@media screen and (max-width: 1920px) {
  .td-width-head {
    font-size: 16px !important;
    height: 44px;
    // padding: 0px 0px;
  }

  .td-width {
    font-size: 16px !important;
    min-height: 50px;
    line-height: 50px;
    padding: 0px;
  }

  .thead-title,
  .table-tbody .td-width-span {
    font-size: 16px !important;
    line-height: 20px !important;
  }

  .span_ {
    height: 22px !important;
    line-height: 22px !important;
    font-size: 16px !important;
  }

  .table-biao {
    border-radius: 3px;
    margin-top: 15px;
  }
  .block13 {
    min-height: 44px;
    line-height: 44px;
  }
  .left-title {
    padding-left: 15px;
    width: 360px;
  }
  .td-width-txt {
    // width: 120px;
  }
  .td-width-txt span {
    margin-right: 8px;
    // min-width: 55px;
  }
  .detail_cont h3 {
    font-size: 20px;
  }
  .dialog_detail_next-title {
    font-size: 16px;
    line-height: 18px;
    height: 18px;
    margin-top: 8px;
    margin-bottom: 20px;
  }
  ::v-deep .el-dialog__body {
    padding: 22px !important;
  }
  ::v-deep .el-checkbox-button__inner {
    font-size: 16px;
  }
  .btn_export {
    width: 160px;
    height: 45px;
    font-size: 16px;
  }

  ::v-deep .dialog_normal {
    width: 600px !important;
  }

  .el-checkbox-button {
    margin-right: 5px;
    width: 87px;
  }
}

@media (max-width: 1439px) {
  .td-width-head {
    font-size: 14px !important;
    height: 34px;
    padding: 6px 0px;
  }

  .td-width {
    font-size: 14px !important;
    min-height: 50px;
  }

  .thead-title,
  .table-tbody .td-width-span {
    font-size: 14px !important;
    line-height: 18px !important;
  }

  .span_ {
    height: 22px !important;
    line-height: 22px !important;
    font-size: 14px !important;
  }

  .table-biao {
    border-radius: 3px;
    margin-top: 13px;
  }
  .block13 {
    min-height: 34px;
    line-height: 34px;
  }
  .left-title {
    padding-left: 13px;
    width: 330px;
  }
  .td-width-txt {
    // width: 100px;
  }
  .td-width-txt span {
    margin-right: 7px;
    // min-width: 50px;
  }
  ::v-deep .el-dialog__body {
    padding: 20px !important;
  }
  .detail_cont h3 {
    font-size: 18px;
  }
  .dialog_detail_next-title {
    font-size: 14px;
    line-height: 16px;
    height: 16px;
    margin-top: 7px;
    margin-bottom: 20px;
  }
  ::v-deep .el-checkbox-button__inner {
    font-size: 14px;
  }
  .btn_export {
    width: 140px;
    height: 40px;
    font-size: 14px;
  }
  ::v-deep .dialog_normal {
    width: 536px !important;
  }
  .el-checkbox-button {
    margin-right: 4px;
    width: 77px;
  }
}
</style>
